import { viewDealProductsListSearchSchema } from '@/modules/product/deals/deals-search-schemas';
import { ViewDealProductsPage } from '@/modules/product/deals/view-deal-products';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/product/deals/view/')({
  validateSearch: viewDealProductsListSearchSchema,
  component: ViewDealProductsPage,
});
